import React, { Fragment } from 'react';
import Loading from '../loading/Loading';
import { useGlobalContext } from "../../context";

function DepartureLocationForm() {
  const {
    departureLocations,
    departureLocation,
    isLoadingDepartures,
    setDepartureLocation} = useGlobalContext();

  const updateDepartureLocation = (e) => {
    e.preventDefault();
    setDepartureLocation(e.target.value);
  }

  return (
    <Fragment>
      <p>Chooses a departure location from the drop down menu below</p>
      {isLoadingDepartures ? <Loading/> :
          <select
            name='departure'
            id='departure-select'
            value={departureLocation}
            onChange={updateDepartureLocation}>
              {departureLocations.map((location, index) => {
                return (
                  <option key={index}>{location}</option>
                )
              })}
          </select>
        }
    </Fragment>
  )
}

export default DepartureLocationForm
